export default __webpack_public_path__ + "0801cb7e570766b9b2171bc939fe07a1.svg";